import axios from "axios";
import qs from "qs";
import AppSettings from "../configs/appSettings";
import Constants from "../helpers/Constants";
import authService from "./AuthorizeService";

//validate response
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      return (window.location.href = Constants.ApplicationPaths.Login);
    }
    if (error.response.status === 403) {
      return (window.location.href = Constants.ApplicationPaths.AccessDeny);
    }
    if (error.response.status === 429) {
      return (window.location.href = Constants.ApplicationPaths.Ratelimit);
    }
    return Promise.reject(error);
  }
);

// Set the AUTH token for any request
axios.interceptors.request.use((request) => {
  if (request.url?.endsWith(Constants.ApiPath.BuildNumber)) {
    return request;
  }
  return authService.getAccessToken().then((token) => {
    request.headers!.Authorization = `Bearer ${token}`;
    return request;
  });
});

class ApiService {
  public get(uri: string, params?: any, customHeader?: any): Promise<any> {
    let config = {};
    if (params) {
      config = {
        params,
        paramsSerializer: (params: any) => {
          return qs.stringify(params);
        },
      };
    }
    if (customHeader) {
      config = { ...config, headers: customHeader };
    }
    return axios.get(`${AppSettings.ApiBaseUrl}/${uri}`, config);
  }

  public downloadFile(uri: string, params?: any): Promise<any> {
    let config = {
      responseType: "blob" as "blob",
      params: params,
    };
    return axios
      .get(`${AppSettings.ApiBaseUrl}/${uri}`, config)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", params.fileName);
        document.body.appendChild(link);
        link.click();
        return response;
      });
  }
}

const apiService = new ApiService();

export default apiService;
